import { AlertTriangle, Trash2, X } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog'

interface ConfirmDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  description?: string
  itemName?: string
}

export function ConfirmDeleteDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Konfirmasi Hapus',
  description = 'Tindakan ini tidak dapat dibatalkan. Data yang dihapus akan hilang dari database secara permanen.',
  itemName,
}: ConfirmDeleteDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogHeader className="border-b border-stone-800 pb-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-500/10 text-rose-500">
            <AlertTriangle className="h-5 w-5" />
          </div>
          <DialogTitle className="text-xl font-semibold text-stone-100">{title}</DialogTitle>
        </div>
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-secondary"
        >
          <X className="h-4 w-4 text-stone-400" />
          <span className="sr-only">Close</span>
        </button>
      </DialogHeader>

      <DialogContent className="py-6">
        <div className="space-y-4">
          <p className="text-sm leading-relaxed text-stone-400">
            {description}
          </p>
          {itemName && (
            <div className="rounded-2xl border border-rose-500/20 bg-rose-500/5 p-4">
              <p className="text-xs font-medium uppercase tracking-wider text-rose-400">Item Akan Dihapus</p>
              <p className="mt-1 font-semibold text-stone-100">{itemName}</p>
            </div>
          )}
        </div>
      </DialogContent>

      <DialogFooter className="border-t border-stone-800 pt-4">
        <button
          onClick={onClose}
          className="rounded-xl border border-stone-800 bg-transparent px-4 py-2 text-sm font-medium text-stone-400 transition hover:bg-stone-900"
        >
          Batalkan
        </button>
        <button
          onClick={() => {
            onConfirm()
            onClose()
          }}
          className="inline-flex items-center gap-2 rounded-xl bg-rose-600 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-rose-600/20 transition hover:bg-rose-500 active:scale-95"
        >
          <Trash2 className="h-4 w-4" />
          Hapus Permanen
        </button>
      </DialogFooter>
    </Dialog>
  )
}
